import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { FunctionComponent } from "react";
import UserDetailProps from "./userDetails";

export const OtherDetails: FunctionComponent<UserDetailProps.OtherDetails> = ({
  sourceFunds,
  setSourceFunds,
  employmentStatus,
  setEmploymentStatus,
  industryType,
  setIndustryType,
  sourceFundList,
  statusList,
  industries,
}) => {
  return (
    <div>
      <div id="otherDetails" className="flex flex-col justify-center mt-5 space-y-1">
        <div id="line1" className="space-y-1">
          <span className="px-3 py-2 bg-gray-300 flex flex-col w-[140px] ml-5 font-bold">
            Other Details *
          </span>
        </div>
        <div id="line2" className="flex space-x-5">
          {/* <FormControl className="w-[400px]">
            <InputLabel id="demo-simple-select-label">Source Of Funds</InputLabel>
            <Select
              required
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={sourceFunds}
              label="Source Of Funds"
              onChange={(e) => setSourceFunds(e.target.value)}
            >
              {sourceFundList.map((element) => (
                <MenuItem key={element} value={element}>
                  {element}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <FormControl className="w-[400px]">
            <InputLabel id="demo-simple-select-label">Employment Status</InputLabel>
            <Select
              required
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={employmentStatus}
              label="Employment Status"
              onChange={(e) => setEmploymentStatus(e.target.value)}
            >
              {statusList.map((element) => (
                <MenuItem key={element} value={element}>
                  {element}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className="w-[400px]">
            <InputLabel id="demo-simple-select-label">Industry Type</InputLabel>
            <Select
              required
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={industryType}
              label="Industry Type"
              onChange={(e) => setIndustryType(e.target.value)}
            >
              {industries.map((element) => (
                <MenuItem key={element} value={element}>
                  {element}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};
